import React, { useState } from "react";
import "./SOPPage.css";
import SOPAccessForm from "../../components/SOPPage/SOPAccessForm/SOPAccessForm";
import SopHeroSection from "../../components/SOPPage/SopHeroSection/SopHeroSection";
import SopSummarySection from "../../components/SOPPage/SopSummarySection/SopSummarySection";
import SopDownloadSection from "../../components/SOPPage/SopDownloadSection/SopDownloadSection";
import SopRelatedLinksSection from "../../components/SOPPage/SopRelatedLinksSection/SopRelatedLinksSection";
import SopCtaSection from "../../components/SOPPage/SopCtaSection/SopCtaSection";
export default function SOPPage() {
  const [code, setCode] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setCode(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (code.trim() === "VanijyamAdmin") {
      setIsAuthorized(true);
      setError("");
      setCode("");
    } else {
      setError("Invalid code. Please try again.");
    }
  }

  if (!isAuthorized) {
    return (
      <div className="sop-page-wrapper">
        <SOPAccessForm
          code={code}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          error={error}
        />
      </div>
    );
  }

  return (
    <div className="sop-page-wrapper content-active">
      <SopHeroSection />
      <SopSummarySection />
      <SopDownloadSection />
      <SopRelatedLinksSection />
      <SopCtaSection />
    </div>
  );
}
